import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Icon from './Icon';
import guideGif from '../assets/yayinci-rehber.gif';

const KEY = 'vokelle_pub_guide_collapsed';

// Yayıncı "kayıttan sonra ne yapacağım" görsel rehberi (sessiz GIF).
// Panelde katlanabilir kart, landing'de sabit görsel olarak kullanılır.
export default function PublisherGuide({ collapsible = true, defaultOpen = true }) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(() => {
    if (!collapsible) return true;
    try {
      const v = localStorage.getItem(KEY);
      return v == null ? defaultOpen : v !== '1';
    } catch (_) { return defaultOpen; }
  });

  const toggle = () => {
    setOpen((o) => {
      const next = !o;
      try { localStorage.setItem(KEY, next ? '0' : '1'); } catch (_) {}
      return next;
    });
  };

  const media = (
    <img
      src={guideGif}
      alt={t('publisher.guide_title')}
      style={{ display: 'block', width: '100%', maxWidth: 640, borderRadius: 10, border: '1px solid var(--border)' }}
    />
  );

  if (!collapsible) return media;

  return (
    <div className="card" style={{ marginBottom: 'var(--sp-4)' }}>
      <button
        type="button"
        onClick={toggle}
        style={{
          width: '100%', background: 'transparent', border: 0, cursor: 'pointer', color: 'inherit',
          display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, padding: 0, textAlign: 'left',
        }}
      >
        <span style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <Icon name="video" size={16} />
          <span style={{ fontWeight: 600 }}>{t('publisher.guide_title')}</span>
        </span>
        <Icon name="arrow" size={14} style={{ transform: open ? 'rotate(90deg)' : 'none', transition: 'transform .15s' }} />
      </button>
      {open && (
        <div style={{ marginTop: 'var(--sp-3)' }}>
          <p style={{ color: 'var(--text-3)', fontSize: 12.5, margin: '0 0 10px' }}>{t('publisher.guide_desc')}</p>
          {media}
        </div>
      )}
    </div>
  );
}
